var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipoHieloIconoEp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.71 76.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 76.71,
    height: 76.71,
    rx: 6.57,
    ry: 6.57,
    fill: "#3fd8ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-45 38.354 11.743)",
    d: "M33.44 6.82h9.83v9.83h-9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.49 48.24h9.83v9.83h-9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-45 38.353 64.974)",
    d: "M33.44 60.05h9.83v9.83h-9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.38 18.75v9.77l-17.03-9.83-17.03 9.83v-9.77h-9.83v9.83h9.83v19.6l17.03 9.83 17.03-9.83v-19.6h9.83v-9.83h-9.83zM31.14 34.32v9.62h-5.11v-12.6h.05l10.86-6.27 2.55 4.42-8.36 4.83zm24.24 13.92h9.83v9.83h-9.83z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoHieloIconoEp);
export default __webpack_public_path__ + "static/media/Tipo_hielo_icono_EP.4feef119f54d8e1accf44664958cb08b.svg";
export { ForwardRef as ReactComponent };